export function parseCsv(csvText) {
  const lines = String(csvText || '').trim().split('\n');
  if (lines.length === 0 || !lines[0]) return [];
  const headers = lines[0].split(',');
  const result = [];
  for (let i = 1; i < lines.length; i += 1) {
    const values = lines[i].split(',');
    const obj = {};
    headers.forEach((header, index) => {
      const value = values[index];
      const headerName = header.trim();
      if (headerName === 'day_group_label' || headerName === 'UnifiedID' ||
          headerName === 't_start' || headerName === 't_end') {
        obj[headerName] = value;
      } else {
        const numValue = parseFloat(value);
        obj[headerName] = Number.isNaN(numValue) ? value : numValue;
      }
    });
    result.push(obj);
  }
  return result;
}
